import { useController } from "react-hook-form"
import { useId } from "react"
import type { Path } from "react-hook-form"
import { Typography } from "@mimber/ui-web"
import { AudienceTargetType } from "@mimber/schema"
import { AudienceSelector } from "@/components/AudienceSelector"
import type {
  AudienceSelectorFieldProps,
  AudienceTargetFields,
} from "./AudienceSelectorField.types"

const { Text } = Typography

export function AudienceSelectorField<
  TFieldValues extends AudienceTargetFields = AudienceTargetFields,
>({
  control,
  disabled,
  label,
  required,
}: AudienceSelectorFieldProps<TFieldValues>) {
  const labelId = useId()
  const { field: targetTypeField, fieldState: targetTypeState } = useController(
    {
      control,
      name: "targetType" as Path<TFieldValues>,
    }
  )

  return (
    <div style={{ marginBottom: 24 }}>
      {label && (
        <div style={{ marginBottom: 8 }}>
          <Text id={labelId}>
            {required && (
              <span style={{ color: "#ff4d4f", marginRight: 4 }}>*</span>
            )}
            {label}
          </Text>
        </div>
      )}
      <AudienceSelector
        value={{
          targetType:
            (targetTypeField.value as AudienceTargetType) ??
            AudienceTargetType.ALL,
        }}
        onChange={(val) => targetTypeField.onChange(val.targetType)}
        disabled={disabled}
        aria-labelledby={label ? labelId : undefined}
      />
      {targetTypeState.error && (
        <div style={{ marginTop: 4 }}>
          <Text type="danger" style={{ fontSize: 12 }}>
            {targetTypeState.error.message}
          </Text>
        </div>
      )}
    </div>
  )
}
